export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkWhy: "nav-link-why",
  linkApp: "nav-link-app",
  linkFounder: "nav-link-founder",
  linkContact: "nav-link-contact",
  ctaDownload: "nav-cta-download",
  mobileMenuToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  ctaAppStore: "hero-appstore",
  ctaPlayStore: "hero-playstore",
};

export const WHY = { root: "why-section" };
export const PANAFRICAN = { root: "panafrican-section" };
export const APP_FEATURES = { root: "app-section" };
export const FOUNDER = { root: "founder-section" };
export const WHILSCO = { root: "whilsco-section" };

export const CONTACT = {
  root: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  message: "contact-input-message",
  submit: "contact-submit",
  whatsapp: "contact-whatsapp",
};

export const DOWNLOAD = {
  root: "download-section",
  appStore: "download-appstore",
  playStore: "download-playstore",
  smart: "download-smart-cta",
};

export const FOOTER = { root: "footer-section" };
